import { reactive, ref } from 'vue'
import type {
  RoleStatusSubscription,
  RoleStatusSubscriptionScheduleType,
} from '@/entities/Role'

export function normalizeStatusTriggers(statuses: string[]): string[] {
  return [...new Set(statuses.map((s) => String(s).trim().toUpperCase()).filter(Boolean))]
}

export function createSubscriptionForm() {
  const editIndex = ref<number | null>(null)
  const localError = ref('')

  const form = reactive({
    object_type_id: null as number | null,
    status_triggers: ['PREACCEPT'] as string[],
    is_active: true,
    schedule_type: 'instant' as RoleStatusSubscriptionScheduleType,
    interval_minutes: 5,
    at_time: '09:00',
    weekdays: [1] as number[],
    month_day: 1,
  })

  const reset = () => {
    editIndex.value = null
    form.object_type_id = null
    form.status_triggers = ['PREACCEPT']
    form.is_active = true
    form.schedule_type = 'instant'
    form.interval_minutes = 5
    form.at_time = '09:00'
    form.weekdays = [1]
    form.month_day = 1
    localError.value = ''
  }

  const validate = (): boolean => {
    if (!form.object_type_id || form.object_type_id <= 0) {
      localError.value = 'Выберите тип элемента'
      return false
    }
    if (!form.status_triggers.length) {
      localError.value = 'Выберите хотя бы один статус'
      return false
    }
    localError.value = ''
    return true
  }

  const buildPayload = (): RoleStatusSubscription => ({
    object_type_id: Number(form.object_type_id),
    status_triggers: normalizeStatusTriggers(form.status_triggers),
    is_active: Boolean(form.is_active),
    schedule: {
      type: 'instant',
    },
  })

  const save = (list: RoleStatusSubscription[]): boolean => {
    const currentEditItem =
      editIndex.value !== null ? list[editIndex.value] : null

    if ((!form.object_type_id || form.object_type_id <= 0) && currentEditItem?.object_type_id) {
      form.object_type_id = Number(currentEditItem.object_type_id)
    }

    if (!validate()) return false

    const payload = buildPayload()

    if (editIndex.value === null) {
      list.push(payload)
    } else {
      list.splice(editIndex.value, 1, payload)
    }

    reset()
    return true
  }

  const startEdit = (item: RoleStatusSubscription, index: number) => {
    editIndex.value = index
    form.object_type_id = Number(item.object_type_id)
    form.status_triggers = normalizeStatusTriggers(item.status_triggers || [])
    form.is_active = Boolean(item.is_active)
    form.schedule_type = 'instant'
    form.interval_minutes = 5
    form.at_time = '09:00'
    form.weekdays = [1]
    form.month_day = 1
    localError.value = ''
  }

  const remove = (list: RoleStatusSubscription[], index: number) => {
    if (!Array.isArray(list)) return
    if (index < 0 || index >= list.length) return

    list.splice(index, 1)
    if (editIndex.value === index) {
      reset()
      return
    }

    // Keep edit pointer in sync after removing rows before it.
    if (editIndex.value !== null && editIndex.value > index) {
      editIndex.value -= 1
    }
  }

  return { form, editIndex, localError, reset, validate, buildPayload, save, startEdit, remove }
}
